import { render } from "./InputTypeImageUpload.vue?vue&type=template&id=406bbfb1"
import script from "./InputTypeImageUpload.vue?vue&type=script&lang=js"
export * from "./InputTypeImageUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__